export default "__VITE_ASSET__Dc11tgZA__"